import { render, staticRenderFns } from "./v-tooltip.vue?vue&type=template&id=0d68706e&scoped=true"
import script from "./v-tooltip.vue?vue&type=script&lang=js"
export * from "./v-tooltip.vue?vue&type=script&lang=js"
import style0 from "./v-tooltip.vue?vue&type=style&index=0&id=0d68706e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d68706e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/app/node_modules/vuetify/lib/components/VIcon/VIcon.js').default,VBtn: require('/app/node_modules/vuetify/lib/components/VBtn/VBtn.js').default,VTooltip: require('/app/node_modules/vuetify/lib/components/VTooltip/VTooltip.js').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
